import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import mixpanel from 'mixpanel-browser';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import Departments from '../../../common/models/Departments';
import { NavigationLink } from '../../Links/Links';
import NavigationMenuWrapper from './styled/NavigationMenuWrapper';
import NavigationContent from './NavigationContent';
import NavigationMenuNavTitle from './NavigationMenuNavTitle';
import MenuBackground from '../../Overlay';
import TrackingEvents from '../../../common/models/TrackingEvents';
import SalesNewIn from './SalesNewIn';
import withCountryCode from '../../RoutesHoc/RoutesHoc';

const mapStateToProps = ({ api: { menu, categories, hoverContent } }) => ({
  menu,
  categories,
  hoverContent
});

class NavigationMenuDesktop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navIndex: null,
      menuToRender: props.menu.find(el => el.name.toLowerCase() === Departments.getInternalName(props.department))
    };

    this.setNavIndex = this.setNavIndex.bind(this);
    this.getColor = this.getColor.bind(this);
  }

  componentDidMount() {
    const { menu } = this.props;
    if (menu && menu.children) {
      menu.map(currDep => {
        currDep.children.map(topLevelLink => {
          mixpanel.track_links(`#nav-link-${topLevelLink.name}`, TrackingEvents.categorySelected(), {
            department: currDep.name.toLowerCase(),
            category: topLevelLink.name.toLowerCase()
          });
        });
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { department, menu } = this.props;
    if (department !== prevProps.department) {
      // force to re-render elements and apply appear animations
      this.setState(
        {
          menuToRender: [],
          transition: true
        },
        () => {
          this.setState({
            transition: false,
            menuToRender: menu.find(el => el.name.toLowerCase() === Departments.getInternalName(department))
          });
        }
      );
    }
  }

  setNavIndex(navIndex = null) {
    const { hoverShown } = this.props;
    this.setState({ navIndex });
    navIndex && hoverShown();
  }

  getColor(currentTab) {
    const { navIndex } = this.state;
    return navIndex === null || navIndex === currentTab ? '#000' : '#999';
  }

  render() {
    const { hoverContent, department, buildUrlWithCountry } = this.props;
    const { transition, navIndex, menuToRender } = this.state;
    const departmentInternalName = Departments.getInternalName(department);

    const hoverNewIn = hoverContent[`${departmentInternalName.toLowerCase()}_new_in`];
    const hoverSale = hoverContent[`${departmentInternalName.toLowerCase()}_sale`];
    const hoverLeftImg = hoverContent[`${departmentInternalName.toLowerCase()}_hover_left_img`];
    const hoverRightImg = hoverContent[`${departmentInternalName.toLowerCase()}_hover_right_img`];

    return (
      <NavigationMenuWrapper>
        {menuToRender.children &&
          menuToRender.children.map((menuColumn, index) => (
            <NavigationMenuNavTitle
              key={`${menuColumn.name}`}
              mouseOver={() => this.setNavIndex(index)}
              mouseLeave={() => this.setNavIndex()}
            >
              <CSSTransitionGroup
                transitionName="fade-nav"
                transitionAppear
                transitionAppearTimeout={500}
                transitionEnter={false}
                transitionLeave={false}
              >
                <NavigationLink
                  id={`nav-link-${menuColumn.name}`}
                  key={`${department}${menuColumn.name}`}
                  color={this.getColor(index)}
                  padding={index === 0 ? '0 15px 0 0' : '0 15px'}
                  underline={navIndex === index}
                  href={buildUrlWithCountry(menuColumn.url)}
                  data-cy={`nav-link-${menuColumn.name.toLowerCase()}`}
                  cursor="pointer"
                >
                  <span>{menuColumn.name}</span>
                </NavigationLink>
              </CSSTransitionGroup>

              {navIndex === index && menuColumn.children.length > 0 && (
                <Fragment>
                  <NavigationContent
                    applyNewInSales
                    values={menuColumn}
                    hoverLeftImg={hoverNewIn}
                    hoverRightImg={hoverSale}
                    department={department}
                  />
                  <MenuBackground pointerEvents="none" />
                </Fragment>
              )}
            </NavigationMenuNavTitle>
          ))}
        {!transition && (
          <Fragment>
            <SalesNewIn
              navIndex={navIndex}
              menuToRender={menuToRender}
              hoverLeftImg={hoverLeftImg}
              hoverRightImg={hoverRightImg}
              department={department}
              getColor={this.getColor}
              setNavIndex={this.setNavIndex}
            ></SalesNewIn>
            <SalesNewIn
              sales
              navIndex={navIndex}
              menuToRender={menuToRender}
              hoverLeftImg={hoverLeftImg}
              hoverRightImg={hoverRightImg}
              department={department}
              setNavIndex={this.setNavIndex}
            ></SalesNewIn>
          </Fragment>
        )}
      </NavigationMenuWrapper>
    );
  }
}

NavigationMenuDesktop.propTypes = {
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.array,
      name: PropTypes.string,
      url: PropTypes.string
    })
  ),
  hoverContent: PropTypes.objectOf(
    PropTypes.shape({
      men_sale: PropTypes.object,
      women_sale: PropTypes.object,
      men_new_in: PropTypes.object,
      women_new_in: PropTypes.object
    })
  ),
  department: PropTypes.string,
  hoverShown: PropTypes.func
};

NavigationMenuDesktop = connect(mapStateToProps)(NavigationMenuDesktop);

export default withCountryCode(NavigationMenuDesktop);
